import Vue from 'vue';
import Router from 'vue-router';
import mainPage from '@/components/mainPage';
import contactPage from '@/components/contactPage';
import gizlilikPage from '@/components/gizlilikPage';
import searchPage from '@/components/searchPage';
import reservationPage from '@/components/reservationPage';
import reservationSearchPage from '@/components/reservationSearchPage';
import reservationSuccessPage from '@/components/reservationSuccessPage';
import registerLoginPage from '@/components/registerLoginPage';
import dynamicPage from '@/components/dynamicPage';
import profilePage from '@/components/profilePage';
import ticketListPage from '@/components/ticketListPage';
import sssPage from '@/components/sssPage';
import campaniesPage from '@/components/campaniesPage';
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'mainPage',
      component: mainPage
    },
    {
      path: '/iletisim',
      name: 'contactPage',
      component: contactPage
    },
    {
      path: '/gizlilik-sozlesmesi',
      name: 'gizlilikPage',
      component: gizlilikPage
    },
    {
      path: '/search',
      name: 'searchPage',
      component: searchPage
    },
    {
      path: '/rezervasyon',
      name: 'reservationPage',
      component: reservationPage
    },
    {
      path: '/reservation_check',
      name: 'reservationSearchPage',
      component: reservationSearchPage
    },
    {
      path: '/success',
      name: 'reservationSuccessPage',
      component: reservationSuccessPage
    },
    {
      path: '/p/:slug',
      name:'dynamicPage',
      component:dynamicPage
    },
    {
      path: '/register-login',
      name:'registerLoginPage',
      component:registerLoginPage
    },
    {
      path: '/profile',
      name:'profilePage',
      component:profilePage
    },
    {
      path: '/biletlerim',
      name:'ticketListPage',
      component:ticketListPage
    },
    {
      path: '/sss',
      name:'sssPage',
      component:sssPage
    },
    {
      path: '/kampanyalar',
      name:'campaniesPage',
      component:campaniesPage
    }
  ]
});
